module.exports = {"jugar":"Play","instrucciones":"Instructions"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/home/ca.json
// module id = 171
// module chunks = 14